import { defineStore } from "pinia";
import client from "@/utils/axios/admin";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    token: "",
    loading: false,
    errors: {},
  }),

  actions: {
    setToken(token) {
      this.token = token;
    },

    async login(payload) {
      this.loading = true;
      this.errors = {};
      try {
        const res = await client.post("/connex/login", payload);
        return res.data;
      } catch (error) {
        this.errors = error.response?.data?.errors || {};
        return (
          error.response?.data || { success: false, message: error.message }
        );
      } finally {
        this.loading = false;
      }
    },

    async confirmLogin(payload) {
      this.loading = true;
      this.errors = {};
      try {
        const res = await client.post("/connex/login-confirm", payload);
        return res.data;
      } catch (error) {
        this.errors = error.response?.data?.errors || {};
        return error.response?.data || { success: false };
      } finally {
        this.loading = false;
      }
    },
    async confirmOTP(payload) {
      this.loading = true;
      this.errors = {};
      try {
        const res = await client.post("/connex/login-confirm", payload);
        return res.data;
      } catch (error) {
        this.errors = error.response?.data?.errors || {};
        return error.response?.data || { success: false };
      } finally {
        this.loading = false;
      }
    },
    // async getProtectedScript(queryString = "") {
    //   this.loading = true;
    //   try {
    //     const url = `/connex/protected-script?${queryString}`;
    //     const res = await client.get(url);
    //     return res.data;
    //   } catch (error) {
    //     return error.response?.data || { success: false };
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    async getProtectedScript(params = {}, suppressLoading = false) {
      if (!suppressLoading) this.loading = true;
      try {
        const url = `/connex/protected-script`;
        const res = await client.get(url, { params : params});
        return res.data;
      } catch (error) {
        return error.response?.data || { success: false };
      } finally {
        if (!suppressLoading) this.loading = false;
      }
    },

    async getSubscriberDetails() {
      this.loading = true;
      try {
        const res = await client.get("/connex/subscriber-details");
        return res.data;
      } catch (error) {
        return error.response?.data || { success: false };
      } finally {
        this.loading = false;
      }
    },

    clearError(field = null) {
      if (field) {
        delete this.errors[field];
      } else {
        this.errors = {};
      }
    },
  },
});
